export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#4a5f8f] via-[#5a6fa0] to-[#6a7fb0]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="animate-fade-in">
          <h3 className="text-4xl font-bold text-white mb-6">
            레알타드는 도와드릴 준비가 되어 있습니다
          </h3>
          <p className="text-xl text-white/90 mb-4">
            이미 많은 파트너들이 윈카와 함께하고 있습니다. 망설이실 이유가 있나요?
          </p>
          <p className="text-lg text-white/80 mb-8">
            지금 바로 상담 신청 후 메이저 사이트로서의 도약을 시작해보세요.
          </p>
          <a 
            href="https://t.me/realtad_cs" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            상담 텔레그램 문의
          </a>
        </div>
      </div>
    </section>
  );
}
